import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {grey} from 'components/primitives/color';


export class Option extends React.Component {
    static propTypes = {
        innerProps: PropTypes.object,
        innerRef: PropTypes.func,
        isDisabled: PropTypes.bool,
        isSelected: PropTypes.bool,
        isFocused: PropTypes.bool,
        label: PropTypes.string,
        data: PropTypes.object,
        children: PropTypes.node
    };

    render() {
        const {isDisabled, isFocused, isSelected, innerProps, innerRef, children} = this.props;

        return (
            <Wrapper innerRef={innerRef} {...innerProps} highlighted={isFocused || isSelected} isDisabled={isDisabled}>
                {children}
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
  padding: 8px;
  cursor: pointer;
  ${({highlighted}) => highlighted ? (`
    background-color: ${grey.grey800};
  `) : ''}
  ${({isDisabled}) => isDisabled ? (`
    opacity: 0.7;
  `) : ''}
`;
